const EmailCard = ({ children }) => {
  return (
    <div className="card emailCard">
      <div className="cardTitle emailTitle">Email Lord Nelson</div>
      <div className="linksLink">
        <a href="mailto:LordNelson@njaes.rutgers.edu?subject=Bulletin%20Board">
          LordNelson@njaes.rutgers.edu
        </a>
      </div>

      <div className="linksText">
        Please include your first name, age, &amp; state.
      </div>
    </div>
  )
}

export default EmailCard
